<template>
	<div class="performance-concerns">
		<speaker-notes :notes="currentNotes"></speaker-notes>
		<h2>Performance</h2>
		<div class="flex">
			<div>
				<h3>Resources</h3>
				<ul>
					<li>Limited <code class="inline">AudioContext</code>.</li>
				</ul>
			</div>
			<div>
				<h3>Memory</h3>
				<ul>
					<li>Every note is cached. (~10k/each)</li>
					<li>Entire buffer is in memory.</li>
				</ul>
				<div class="test-container">
					<button class="retest" @click="testPerformance"></button>
					<code>
						<div>window.performance.memory = {</div>
						<span class="indent1">usedJSHeapSize : <span v-html="formatNumber(usedJSHeapSize)"></span></span>
						<span class="indent1">totalJSHeapSize: <span v-html="formatNumber(totalJSHeapSize)"></span></span>
						<span class="indent1">jsHeapSizeLimit: <span v-html="formatNumber(jsHeapSizeLimit)"></span></span>
						<div>};</div>
					</code>
				</div>
			</div>
		</div>
		<div v-if="part === 2">
			<music-display :abc="allNotesOnPiano()" :has-audio="true" :options="options"></music-display>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import PageParts from "../helpers/page-parts";
	import MusicDisplay from "../components/MusicDisplay";
	import SpeakerNotes from "../components/SpeakerNotes";
	export default {
		name: "performance-concerns",
		components: {SpeakerNotes, MusicDisplay},
		mixins: [
			PageParts,
		],
		computed: {
			options() {
				let options = Object.assign({}, this.abcjsOptions());
				//options.scale = 0.8;
				return options;
			}
		},
		data() {
			return {
				jsHeapSizeLimit: 0,
				totalJSHeapSize: 0,
				usedJSHeapSize: 0,
				notes: [
					[
						"Can run out of AudioContext.",
						"With uncertain garbage collection, it can happen at any time.",
						"This includes all the browser tabs you have open.",
						"Every note is cached. Practically, that hasn't used up much memory.",
						"Seems to be no need for cache invalidation.",
					],
					[
						"This is every note on the piano. Probably a maximum.",
						"\"Every note on every instrument\" was too much.",
						"It took about 5 minutes to load, but then it actually played.",
					],
				],
			};
		},
		mounted() {
			this.testPerformance();
		},
		methods: {
			...mapGetters(['allNotesOnPiano', 'abcjsOptions']),
			formatNumber(x) {
				x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				const pad = 13-x.length;
				for (let i = 0; i < pad; i++) {
					x = '&nbsp;' + x;
				}
				return x;
			},
			testPerformance() {
				if (window.performance && window.performance.memory) {
					this.jsHeapSizeLimit = window.performance.memory.jsHeapSizeLimit;
					this.totalJSHeapSize = window.performance.memory.totalJSHeapSize;
					this.usedJSHeapSize = window.performance.memory.usedJSHeapSize;
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.performance-concerns {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	@media screen and (min-width: 490px) {
		.flex {
			display: flex;
			justify-content: space-evenly;
			width: 100%;
		}
	}
	.test-container {
		position: relative;
	}
	.retest {
		width: 70px;
		height: 65px;
		background-image: url("../assets/images/retest.png");
		border: 4px solid $button-border2;
		border-radius: 16px;
		box-shadow: $button-shadow;
		position: absolute;
		right: -10px;
		bottom: 25px;
		&:hover {
			border: 3px solid $button-border2;
			height: 62px;
			width: 66px;
		}
	}
	@media screen and (min-width: 490px) {
		.retest {
			right: -24px;
		}
	}
</style>
